import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-image.tsx
var LazyImage = lazy(() => import("./image-Dtf1hACY.js").then((n) => n.n).then((module) => ({ default: module.Image })));
function Image({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "image" }),
		children: /* @__PURE__ */ jsx(LazyImage, { ...props })
	});
}
function ImageContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "image" }),
		children: /* @__PURE__ */ jsx(LazyImage, { ...props })
	});
}
var useImageContent = () => {
	return useMemo(() => ({ image: { component: ImageContent } }), []);
};
//#endregion
export { Image, useImageContent };
